import { useState } from "react";
import { useTranslation } from 'react-i18next';
import Irregular from "../../../components/class/ocean/Irregular";
import Regular from "../../../components/class/ocean/Regular";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Radio from "../../../components/Radio";

const ClassOcean = () => {
  const [isRegular, setIsRegular] = useState(true);
  const { t } = useTranslation();

  return (
    <>
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label></label>
              <Radio
                checked={isRegular}
                onChange={() => setIsRegular(true)}
                text={t("class.ocean.option1")}
              />
              <Radio
                className="ml-4"
                checked={!isRegular}
                onChange={() => setIsRegular(false)}
                text={t('class.ocean.option2')}
              />
            </li>
          </ul>
        </div>
      </div>	
      <div className="content scrollbar">
        <SimpleHeader
          iconFile="icon-student-big.svg"
          parentMenu={t('common.menu.class')}
          currentMenu="OCEAN"
          onlyTitle={true}
        />

        <div>
          {
            isRegular
              ? <Regular />
              : <Irregular />
          }
        </div>
      </div>
    </>
  );
}

export default ClassOcean;
